import { KioskTransactionType } from '@groundfloor-platform/mgmt-service-g-sdk';
import { SVGIconComponent } from '../../../../ui/components/pure/icons/types';
import { mapTransactionTypesToIcons } from '../../../deliveries/maps/kiosk-transaction-types-to-icons.map';

/** Where a courier's capabilities come from. */
export type CourierCapabilityGrants = {
  /** The carrier's, which every courier in it holds. */
  inherited: KioskTransactionType[];
  /** Granted to this courier alone. */
  direct: KioskTransactionType[];
};

export type CourierCapabilityIcon = {
  Icon: SVGIconComponent;
  /** The delivery type — unique across the row, so it keys the icon. */
  label: string;
  tooltip: string;
  isDirect: boolean;
};

export const MAX_CAPABILITY_ICONS = 7;

/**
 * One icon per delivery type, inherited first. Reached both ways it is drawn once, as direct —
 * a courier holding something in their own right is the exception worth seeing.
 */
export function makeCourierCapabilityIcons({ inherited, direct }: CourierCapabilityGrants): CourierCapabilityIcon[] {
  const directIcons = mapTransactionTypesToIcons(direct);
  const directLabels = new Set(directIcons.map((icon) => icon.label));

  const inheritedIcons = mapTransactionTypesToIcons(inherited).filter((icon) => !directLabels.has(icon.label));

  return [
    ...inheritedIcons.map((icon) => toCapabilityIcon(icon, false)),
    ...directIcons.map((icon) => toCapabilityIcon(icon, true))
  ];
}

function toCapabilityIcon(
  icon: { Icon: SVGIconComponent; label: string; transactionTypeLabels: string[] },
  isDirect: boolean
): CourierCapabilityIcon {
  return {
    Icon: icon.Icon,
    label: icon.label,
    tooltip: `${isDirect ? 'Granted to this courier' : 'From the carrier'} · ${icon.transactionTypeLabels.join(', ')}`,
    isDirect
  };
}
